import features from '@nobia/zeus-components/lib/features'
import settings from '@nobia/zeus-components/lib/settings'
import { useMemo } from 'react'

import { useTranslation } from '../utils/useTranslation'

export const useRoutes = () => {
  const { intl } = useTranslation()

  const routes = useMemo(
    () => ({
      home: {
        path: intl.formatMessage({ id: 'app.routes.home.path' }, '/'),
        title: intl.formatMessage({ id: 'app.routes.home.title' }, 'Home'),
      },
      designs: {
        path: intl.formatMessage(
          { id: 'app.routes.designs.path' },
          '/designs/'
        ),
        title: intl.formatMessage(
          { id: 'app.routes.designs.title' },
          'Designs'
        ),
      },
      messages: {
        path: intl.formatMessage(
          { id: 'app.routes.messages.path' },
          '/messages/'
        ),
        title: intl.formatMessage(
          { id: 'app.routes.messages.title' },
          'Messages'
        ),
      },
      appointment: {
        path: intl.formatMessage(
          { id: 'app.routes.appointment.path' },
          '/appointment/'
        ),
        title: intl.formatMessage(
          { id: 'app.routes.appointment.title' },
          'Appointment'
        ),
      },
      order: {
        path: intl.formatMessage({ id: 'app.routes.order.path' }, '/order/'),
        title: intl.formatMessage({ id: 'app.routes.order.title' }, 'Order'),
      },
      saved: {
        path: intl.formatMessage({ id: 'app.routes.saved.path' }, '/saved/'),
        title: intl.formatMessage({ id: 'app.routes.saved.title' }, 'Saved'),
      },
      design: {
        path: intl.formatMessage(
          { id: 'app.routes.design.path' },
          '/design/:customerId/:quoteId/'
        ),
        title: intl.formatMessage({ id: 'app.routes.design.title' }, 'Design'),
      },
      multiStore: {
        path: intl.formatMessage(
          { id: 'app.routes.multi-store.path' },
          '/stores/'
        ),
        title: intl.formatMessage(
          { id: 'app.routes.multi-store.title' },
          'Stores'
        ),
      },
    }),
    [intl]
  )

  return routes
}

export const canNavigateToAppointmentsPage = (storeId) => {
  if (features.multiStore === true) {
    if (settings.brand === 'marbodal') {
      return true
    } else if (['hthdk', 'hthno', 'hthse'].includes(settings.brand)) {
      return true
    }
    return settings.store?.franchiseStoreIds?.includes(storeId)
  }
  return true
}

export const canNavigateToDesignsPage = (storeId) => {
  if (features.multiStore === true) {
    return settings.store?.franchiseStoreIds?.includes(storeId)
  }
  return true
}

export const canNavigateToMessagesPage = (storeId) => {
  if (features.multiStore === true) {
    return settings.store?.franchiseStoreIds?.includes(storeId)
  }

  return true
}

export const canNavigateToOrderPage = (storeId) => {
  if (features.multiStore === true && features.storeOrders === true) {
    return settings.store?.franchiseStoreIds?.includes(storeId)
  }
  return true
}

export const canNavigateToHelpOrderTab = (storeId) => {
  if (features.multiStore === true) {
    return settings.store?.franchiseStoreIds?.includes(storeId)
  }
  return true
}

export const canNavigateToHelpDesignsTab = (storeId) => {
  if (features.multiStore === true) {
    return settings.store?.franchiseStoreIds?.includes(storeId)
  }
  return true
}
